import { InstagramPositionEnum, OldInstagramPositionEnum } from "../enums";

export const mapInstagramPosition: any = {
    [OldInstagramPositionEnum.stream]: InstagramPositionEnum.FEED,
    [OldInstagramPositionEnum.story]: InstagramPositionEnum.STORY,
    [OldInstagramPositionEnum.explore]: InstagramPositionEnum.EXPLORE,
    [OldInstagramPositionEnum.reels]: InstagramPositionEnum.REELS,
}